import List from '@material-ui/core/List';
import Grid from '@material-ui/core/Grid';
import AssetRarityButtonGroup from "./assetRarityButtonGroup/AssetRarityButtonGroup";
import { CircularProgress, Typography } from "@material-ui/core";
import { modalContentColor, modalMainContentColor } from "../lib/Color";
import { HeroDataType, FilterRarityType } from "./hooks/AssetSettingModalType";
import { PositionType } from '../Type/TeamType';
import { useState, useEffect } from 'react';
import { AssetToolTip } from './AssetToolTip';

type Props = {
    isAuto: boolean;
    filterRarity: FilterRarityType;
    selectedPosition: PositionType;
    heros: HeroDataType[]
    filterHeroData: (heros: HeroDataType[], rarity: FilterRarityType) => HeroDataType[];
    updateTeamMemberHeroData: (hero: HeroDataType) => void,
    onSelectStatePosition: (position: PositionType) => void,
    onSelectStateFilterRarity: (rarity: FilterRarityType) => void,
    nextStateMode: () => void
}

const HeroSettingContent = ({ heros, isAuto, filterRarity, selectedPosition, filterHeroData, updateTeamMemberHeroData, onSelectStatePosition, nextStateMode, onSelectStateFilterRarity }: Props) => {
    const [heroData, setHeroData] = useState<HeroDataType[]>([]);

    useEffect(() => {
        setHeroData(filterHeroData(heros, filterRarity))
    }, [heros, filterRarity])
    const nextTeamPosition = (): PositionType => {
        switch (selectedPosition) {
            case "FRONT":
                return "MIDDLE";
            case "MIDDLE":
                return "BACK";
            case "BACK":
                return "FRONT"
        }
    }
    const updateMember = (hero: HeroDataType) => {
        updateTeamMemberHeroData(hero)
        if (!isAuto) return

        if (selectedPosition === "BACK") {
            nextStateMode()
        } else {
            onSelectStatePosition(nextTeamPosition())
        }
    }


    return (
        <>
            <Grid container style={{ backgroundColor: modalContentColor, height: '80vh' }} alignItems="center" justify="center">
                <Grid item >
                    <AssetRarityButtonGroup selectedRarity={filterRarity} onSelectStateFilterRarity={onSelectStateFilterRarity} />
                </Grid>
                <Grid item style={{ height: '90%', width: "100%", margin: "10px", overflow: "auto", backgroundColor: modalMainContentColor, borderColor: "white" }}>
                    <List>
                        {heroData.length ? heroData.map((hero) => {
                            return <AssetToolTip
                                title={
                                    <>
                                        <Typography color="inherit">{hero.name}</Typography>
                                        <Typography color="inherit">{hero.passive}</Typography>
                                        <Typography color="inherit">{hero.trigger}</Typography>
                                        <Typography color="inherit">HP: {hero.hp} PHY: {hero.phy} INT: {hero.int} AGI: {hero.agi}</Typography>
                                    </>
                                }
                            >
                                <img onClick={() => updateMember(hero)}
                                    src={"/images/heroes/" + hero.id + ".png"}
                                    style={{ width: 64, height: 64 }}
                                />
                            </AssetToolTip>
                        }) : <CircularProgress disableShrink />}
                    </List>
                </Grid>
            </Grid >
        </>
    );
}

export default HeroSettingContent;